import { useState } from 'react';
import { useSelector } from 'react-redux';
import selectorUser from '@redux/user/selectors';
import { notification, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import { FormButton } from 'common/components';

import Messages from 'i18n/messages/qa-spec';
import { useIntl } from 'react-intl';

import * as api from 'config/axios';
import * as qaSpecServices from 'services/qaSpec';

import { useCheckDisableDownloadProduct } from 'hooks/useCheckDisableDownload';
import { useGetProductFullView } from 'hooks';
import { checkIsDollarProduct } from 'utils/checkIsOwner';
import { checkIsSuperAdmin } from 'utils';

import './DownloadSpecButton.less';

const DownloadSpecButton = (props) => {
  const intl = useIntl();
  const userInfo = useSelector(selectorUser.makeSelectUserInfo());
  const { roles } = userInfo ?? {};
  const isSuperAdmin = checkIsSuperAdmin(roles);
  const { productId } = props;

  const [loading, setLoading, message] = useState(false);

  const { productFull } = useGetProductFullView({ productId: productId });
  const ownerId = productFull?.ownerId;
  const type = productFull?.type;
  const isDollarGeneral = checkIsDollarProduct(ownerId);
  const isDollarPet = isDollarGeneral && type === 'Pet';

  const memberId = String(userInfo?.companyId);
  const isAdminParam = isSuperAdmin ? "1" : "0";

  const { disableDownloadProduct } = useCheckDisableDownloadProduct();

  const downloadSpec = () => {
    setLoading(true);

    qaSpecServices
      .getDownloadQaSpecUrl({
        productId,
      })
      .then((response) => {
        const { isSuccess, data } = response;

        if (isSuccess && data?.fileUrl)
          api.sendDownload({ url: data?.fileUrl });
        else notifyError(message);
      })
      .catch(() => notifyError())
      .finally(() => {
        setLoading(false);
      });
  };

  const exportPaginatedReport = () => {
    setLoading(true);

    const payload = {
      format: "PDF",
      parameters: [
        {
          name: "MemberID",
          value: memberId
        },
        {
          name: "IsAdmin",
          value: isAdminParam
        },
        {
          name: "ProductID",
          value: String(productId)
        }
      ],
      productId: productId
    };

    qaSpecServices
      .getPowerBiDownloadQaSpecUrl(payload)
      .then((response) => {
        const { isSuccess, data } = response;

        if (isSuccess && data?.fileUrl)
          api.sendDownload({ url: data?.fileUrl });
        else notifyError(message);
      })
      .catch(() => notifyError())
      .finally(() => {
        setLoading(false);
      });
  };


  const notifyError = (message) => {
    notification.error({
      message: message || intl.formatMessage(Messages.downloadQaSpecError),
    });
  };

  return (
    <Tooltip title={intl.formatMessage(Messages.downloadQaSpecBtn)}>
      <FormButton
        disabled={disableDownloadProduct}
        className='qa-spec__btn-download-spec'
        text={isDollarPet ? null : intl.formatMessage(Messages.downloadQaSpecBtn)}
        icon={<DownloadOutlined />}
        onClick={exportPaginatedReport}
        loading={loading}
      />
    </Tooltip>
  );
};
export default DownloadSpecButton;
